import { Paginator } from 'foundations-components/transitional/components/Paginator';
import { jsx as _jsx } from "react/jsx-runtime";
export function TablePaginator({
  currentPage,
  hasMore,
  hasPrev,
  onNextPage,
  onPrevPage,
  loading = false,
  totalResultsCount,
  pageSize
}) {
  if (!hasMore && !hasPrev) {
    return null;
  }
  function handlePageChange({
    target: {
      value: newPage
    }
  }) {
    if (loading) {
      return;
    }
    if (newPage === currentPage + 1) {
      onNextPage === null || onNextPage === void 0 || onNextPage();
    } else if (newPage === currentPage - 1) {
      onPrevPage === null || onPrevPage === void 0 || onPrevPage();
    }
  }
  return /*#__PURE__*/_jsx(Paginator, {
    page: currentPage,
    pageCount: Math.ceil(totalResultsCount / pageSize),
    maxVisiblePageButtons: 3,
    onPageChange: handlePageChange
  });
}